export default {"src":"/_next/static/image/assets/img/svg/bgChildHome.5cab40537dfbf0cc33c69890d604c499.svg","height":265,"width":273};